































import { ImageSourceSet } from 'client-website-ts-library/types';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Masthead extends Vue {
  @Prop()
  public readonly darken!: boolean;

  @Prop()
  public readonly image!: string | ImageSourceSet;

  @Prop()
  public readonly relativeContent!: boolean;
}
